module.exports = __webpack_public_path__ + "static/media/Spitalfields (4).d26a3a0c.JPG";